<template>
  <v-col :cols="isPadBool ? (isPhoneBool ? 12 : (Id ? 7 : 5)) : (Id ? 0 : 2)">
    <section-header :title="$t('servicesystem.common_objects.job.invoice_customer')"
                    :leftpad="'pl-4'" :notoppad="true" :no-clutter="true">
      <template v-slot:button>
        <v-btn v-if="Id"
               @click="selectmode = !selectmode"
               small
               :outlined="selectmode"
               class="mr-4"
               :color=" selectmode ? 'error' : 'primary'">
          <v-icon :class="isPhoneBool ? '' : 'mr-3'"
                  size="16">{{selectmode? 'mdi-close' : 'mdi-format-list-bulleted'}}</v-icon>
          {{ isPhoneBool ? '' : (selectmode ? $t('servicesystem.common_objects.commonterms.cancel') : $t('servicesystem.common_objects.commonterms.change')) }}
        </v-btn>
        <v-btn v-if="Id"
               @click="SetOrderCustomer(customerId)"
               small
               class="mr-4"
               :color="'error'">
          <v-icon :class="isPhoneBool ? '' : 'mr-3'"
                  size="16">{{'mdi-delete'}}</v-icon>
          {{ isPhoneBool ? '' : $t('servicesystem.common_objects.commonterms.remove') }}
        </v-btn>
      </template>
    </section-header>

    <v-card v-if="!Id || selectmode"
            color="transparent"
            class="d-flex align-center justify-center pa-5 mt-3"
            style="border: 2px dashed #bdbdbd !important;"
            elevation="0">
      <div class="d-flex flex-column justify-center">
        <div class="text-center mb-4">{{$t('servicesystem.common_objects.fallbackterms.no_invoice_customer')}}</div>
        <v-btn v-if="!selectmode"
               color="primary"
               @click="selectmode = true">
          {{$t('servicesystem.common_objects.commonterms.select_customer')}}
        </v-btn>
        <CustomerSelect v-else
                        dense
                        v-model="Id"
                        :excludedId="customerId"
                        @click="SetOrderCustomer"
                        :loading="false">
        </CustomerSelect>
      </div>
    </v-card>

    <CustomerInvoiceOptionsCard v-else
                                :jobId="jobId"
                                :customerId="Id"
                                :contactId="ContactId"
                                :isOrder="true">
    </CustomerInvoiceOptionsCard>

  </v-col>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import CustomerSelect from "@/components/CustomerSelect.vue";
import SectionHeader from "@/components/ExpancionPanels/Parts/SectionHeader.vue";
import CustomerInvoiceOptionsCard from "@/views/job/viewjob/invoice/CustomerInvoiceOptionsCard.vue";

export default {
  name: "AlternativeInvoiceCustomerCard",
  props: {
    jobId: [Number, String],
    customerId: [Number, String],
    alternativeCustomerId: [Number, String],
    alternativeContactId: [Number, String],
  },
  components: {
    SectionHeader,
    CustomerInvoiceOptionsCard,
    CustomerSelect,
  },
  mixins: [clientAPI],

  data() {
    return {
      Id: null,
      ContactId: null,
      loading: false,
      selectmode: false,
    };
  },

  mounted() {
    this.SetId();
    this.SetContactId();
  },

  methods: {
    SetId() {
      if (this.alternativeCustomerId != this.customerId) {
        this.Id = this.alternativeCustomerId;
      } else {
        this.Id = null;
      }
    },

    SetContactId() {
      this.ContactId = this.alternativeContactId;
    },

    SetOrderCustomer(newcustomerId) {
      this.loading = true;
      //console.log("Sent", newcustomerId);
      this.SetInvoiceCustomer(this.jobId, newcustomerId, null)
        .then((response) => {
          this.$store.dispatch("JobHub/JobParentjob/setJobOrderField", {
            key: "CustomerId",
            value: response.Customer.Id,
          });
          this.$store.dispatch("JobHub/JobParentjob/setJobOrderField", {
            key: "CustomerPersonId",
            value: response.CustomerPerson.Id,
          });
          //this.Id = response.Customer.Id;
          //this.ContactId = response.CustomerPerson.Id;
          this.selectmode = false;
          //console.log("Recieved", response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  computed: {},

  watch: {
    alternativeCustomerId: function () {
      this.SetId();
    },
    alternativeContactId: function () {
      this.SetContactId();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>